import axios from "axios";

const endpoint_url = "/message/whatsappAnalytic/getPerformanceByTemplateUuid";

const getTemplatePerformanceAnalytic = ({whatsappMessageTemplateUuid, startDate, endDate}) => {
  return new Promise((resolve, reject) => {
    let paramsField =[
      ['whatsapp_message_template_uuid', whatsappMessageTemplateUuid]
    ];

    if(startDate){
      paramsField.push(['start_date', startDate]);
    }

    if(endDate){
      paramsField.push(['end_date', endDate]);
    }

    const params = new URLSearchParams(paramsField);
    axios
      .get(endpoint_url,{params})
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getTemplatePerformanceAnalytic;
